<template>
    <div class="container marketing">
        <v-row id="s1">
            <div class="col-md-12 col-md-offset-2" style="margin-bottom:15px; text-align:center;">
                <h1 style="margin-top:100px;">{{title}}</h1>
                <p>
                    <span v-html="description"></span><br/>
                    <span v-html="description1"></span>
                </p>
                <br/>
                <v-btn :color="buttonColor" :href="urlDashboard" class="btn" style="color: white;">
                    {{$t("cancelRegistration.back_to_dashboard")}}
                </v-btn>
            </div>
        </v-row>
    </div>
</template>

<script>
import {
    VBtn, VRow
} from 'vuetify/lib';
import axios from "axios";

export default {
    components: {
      VBtn, VRow
    },
    data() {
        return {
            buttonColor: "#000",
            isError: false,
        };
    },
    computed: {
        urlDashboard() {
            return this.$store.getters.env.get('VUE_APP_BASE') + 'dashboard';
        },
        title() {

            return !this.isError ? this.$t("cancelRegistration.canceled_info") : this.$t("cancelRegistration.error-message");
        },
        description() {
            return !this.isError ? this.$t("cancelRegistration.mistake_info") : this.$t("cancelRegistration.error-description");
        },
        description1() {
            return !this.isError ? '' : this.$t("cancelRegistration.error-description1");
        }
    },
    created(){
        this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
    },
    async mounted() {
        if(this.$route.query.pp == 1){
            const response = await axios.get(`${this.$store.getters.env.get('VUE_APP_ROOT')}/laravel/public/api/v1/participant/register/event/cancelPaypalRegistration/${this.$route.query.eId}`);
            //dont know why we have to put this inside the if for it to be read, but whatever
            if(response && response.data && response.data.success == 0){
                this.isError = true;
            }else{
                this.$store.dispatch("setUnPaidRegistration",false);
            }

        } else {
            const response = await axios.get(`${this.$store.getters.env.get('VUE_APP_ROOT')}/laravel/public/api/v1/participant/register/event/cancelLivelapsRegistration/${this.$route.query.eId}`);
            //dont know why we have to put this inside the else for it to be read, but whatever
            if(response && response.data && response.data.success == 0){
                this.isError = true;
            }else{
                this.$store.dispatch("setUnPaidRegistration",false);
            }
        }
        
    },
    
}
</script>
<style>
.v-progress-linear--absolute {
    display: none;
}
</style>